import React from 'react'
import Layout from '../../../components/corporateAdmin/Layout'
import { Helmet } from 'react-helmet'
import Chart from '../../../components/ui/demo/Chart'

function Revenue() {
  return (
    <div>
            <Layout>
             <Helmet>
                    <title>Admin - Revenue</title>
                </Helmet>
                <Chart title="Total Revenue"/>

            </Layout>
        </div>
  )
}

export default Revenue
